export default {
  GET_TENANT_FIELDS: 'getTenantFields',
}
